import { getSyncEngine, type SyncStatus } from './sync/engine';

export class OfflineError extends Error {
  constructor(message = 'This action requires an internet connection') {
    super(message);
    this.name = 'OfflineError';
  }
}

export function isOnline(): boolean {
  if (typeof navigator !== 'undefined' && 'onLine' in navigator) {
    return navigator.onLine;
  }
  return true;
}

export function getSyncStatus(): SyncStatus {
  return getSyncEngine().getStatus();
}

/** Local SQLite is populated and safe for database CRUD. */
export function canUseLocalDatabase(): boolean {
  const engine = getSyncEngine();
  const db = engine.getDatabase();
  if (!db) {
    return false;
  }
  const status = engine.getStatus();
  return (
    status === 'ready' ||
    status === 'syncing' ||
    status === 'bootstrapping' ||
    status === 'error'
  );
}

export function requireOnlineForImportExport(): void {
  if (!isOnline()) {
    throw new OfflineError('Import and export require an internet connection');
  }
}
